export default "__VITE_ASSET__Dn58R9Sv__"